<script setup lang="ts">
import { useTimeout } from '@vueuse/core'
import clsx from 'clsx'
import { CollapsibleContent } from 'radix-vue'

const props = withDefaults(
  defineProps<{
    animation?: keyof typeof animations
    duration?: number
  }>(),
  {
    animation: 'normal',
    duration: 300,
  }
)

const animations = {
  normal: 'animate-collapse-normal',
}

// Wait for the component to be mounted before animating
const ready = useTimeout(props.duration + 50, {
  immediate: true,
})
</script>

<template>
  <CollapsibleContent
    :class="
      clsx(animations[props.animation], {
        animate: ready,
        'collapse-not-ready': !ready,
      })
    "
    role="region"
    tabindex="-1"
  >
    <slot />
  </CollapsibleContent>
</template>

<style>
.collapse-not-ready[data-state='closed'] {
  display: none;
}

.animate.animate-collapse-normal[data-state='open'] {
  animation-name: slideDown;
  animation-duration: v-bind(duration + 'ms');
  animation-timing-function: ease-out;
}

.animate.animate-collapse-normal[data-state='closed'] {
  animation-fill-mode: forwards;
  animation-name: slideUp;
  animation-duration: v-bind(duration + 'ms');
  animation-timing-function: ease-out;
}

@keyframes slideDown {
  from {
    height: 0;
    overflow: hidden;
  }
  to {
    height: var(--radix-collapsible-content-height);
  }
}

@keyframes slideUp {
  from {
    height: var(--radix-collapsible-content-height);
    overflow: hidden;
  }
  to {
    height: 0;
    overflow: hidden;
  }
}
</style>
